import { ForestModal } from "../game-shell/ForestModal";
import { createPortal } from "react-dom";

/** Global approval prompt for value-moving custodial signatures (§8.3). */
export function CustodialApprovalHost({
  message,
  onConfirm,
  onCancel,
}: {
  message: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  if (!message) return null;
  return createPortal(
    <ForestModal title="Confirm transaction" onClose={onCancel}>
      <p>Review the exact message your connected wallet will sign.</p>
      <pre className="forest-approval-message" aria-label="Transaction message">{message}</pre>
      <div className="forest-modal-actions">
        <button data-modal-autofocus onClick={onCancel}>Cancel</button>
        <button className="forest-primary" onClick={onConfirm}>Continue to wallet</button>
      </div>
    </ForestModal>,
    document.querySelector(".forest-app") ?? document.body,
  );
}
